import Box from 'v2/components/UI/Box';
import Button from 'v2/components/UI/ButtonBase';
import moment from 'moment';

import { STATUS_COLOR } from './types';
import Icon from 'v2/components/Icon';
import Text from 'v2/components/UI/Text';
import { ICycle } from 'v2/resources/types/cycles';

import { ReactComponent as FishIcon } from '../../../../assets/icons/peixe-icon.svg';
import { ReactComponent as ShrimpIcon } from '../../../../assets/icons/camarão-icon.svg';

import useCycles from './hooks/useCycles';

//TODO: USE IN FUTURE
import DropDown from 'v2/components/UI/DropDown';
import ModalNursery from 'v2/pages/Home/components/ModalNursery';

const Cycles: React.FC<ICycle> = ({ begin, code, end, id, ponds }) => {
  const {
    openDropdownIndex,
    options,
    dataModalNursery,
    openModalNursery,
    isMobile,
    isTablet,

    handleCloseModalNursery,
    handleOpenModalNursery,
    handleOpenDropdown,
    handleNavigateOptions,
  } = useCycles();

  const renderIcon = (specie_category: string, color: string) => {
    if (specie_category === 'Camarão') {
      return <ShrimpIcon width={26} height={26} color={color} fill={color} />;
    }

    return <FishIcon width={26} height={26} color={color} fill={color} />;
  };

  const renderCardCycle = () => {
    return (
      <Box width="100%" gap={'2%'} flexWrap="wrap">
        {ponds.map((pond, index) => {
          const COLOR =
            STATUS_COLOR[`${pond.status as keyof typeof STATUS_COLOR}`];
          const isDropdownOpen = openDropdownIndex === index;
          return (
            <Button
              padding={25}
              gap={15}
              flexDirection="column"
              background={'#fff'}
              borderRadius={16}
              width={'100%'}
              minWidth={300}
              maxWidth={isMobile || isTablet ? '100%' : '32%'}
              marginBottom={'2%'}
              border={`0.5px solid ${COLOR}`}
              key={index}
              position="relative"
              onClick={() => handleOpenModalNursery(id, pond.id)}
            >
              <Box
                alignItems="center"
                width={'100%'}
                justifyContent="space-between"
              >
                <Box gap={5} alignItems="center">
                  <Text fontSize={14} fontWeight={500}>
                    {pond.type}
                  </Text>
                  <Text fontSize={14} fontWeight={500}>
                    |
                  </Text>
                  <Text fontSize={14} fontWeight={500}>
                    {pond.system}
                  </Text>
                </Box>

                <Text fontSize={14} fontWeight={700} color={COLOR}>
                  {pond.status}
                </Text>
              </Box>

              <Box textTransform="uppercase">
                <Text fontSize={24} fontWeight={700} color={COLOR}>
                  {pond.description}
                </Text>
              </Box>

              <Box flexDirection="column" gap={10} width={'100%'}>
                <Box
                  width={'100%'}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Text fontSize={13} fontWeight={500}>
                    Início: {moment(pond.begin).format('DD/MM/YYYY')}
                  </Text>
                  <Text fontSize={13} fontWeight={500}>
                    Fim: {moment(pond.end).format('DD/MM/YYYY')}
                  </Text>
                </Box>

                <Box
                  width={'100%'}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Text fontSize={13} fontWeight={500}>
                    Ração usada: {pond.totalFoodOffered}kg
                  </Text>
                  <Text fontSize={13} fontWeight={500}>
                    Total despescado: {pond.usedFeed ?? 0}
                  </Text>
                </Box>
              </Box>

              <Box
                width={'100%'}
                justifyContent="space-between"
                alignItems="center"
              >
                <Box alignItems="center" gap={5}>
                  <Icon
                    htmlColor="#000000Ed"
                    iconName="CalendarTodayOutlined"
                    size={18}
                  />
                  <Text fontSize={13} fontWeight={500}>
                    {pond.growingDays ?? 0} dias de cultivo
                  </Text>
                </Box>

                <Box
                  alignItems="center"
                  gap={5}
                  marginRight={-12}
                  marginTop={5}
                >
                  {renderIcon(pond.specie_category, COLOR)}{' '}
                  <Icon
                    iconName="MoreVertOutlined"
                    htmlColor={COLOR}
                    size={28}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenDropdown(index);
                    }}
                  />
                  {isDropdownOpen && (
                    <Box
                      position="absolute"
                      bottom={-40}
                      right={-10}
                      background={'#fff'}
                      border={`1px solid ${COLOR}`}
                      borderRadius={8}
                      zIndex={1000}
                      flexDirection="column"
                    >
                      {options.map(({ title, route }) => (
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleNavigateOptions(route, id, pond);
                          }}
                          fontWeight={600}
                          background={`${COLOR}60`}
                          padding={'12px 20px'}
                        >
                          {title}
                        </Button>
                      ))}
                    </Box>
                  )}
                </Box>
              </Box>
            </Button>
          );
        })}
      </Box>
    );
  };

  return (
    <Box gap={30} flexDirection="column" width={'100%'}>
      <Box
        width={'100%'}
        gap={'5%'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Text
          fontSize={16}
          color="#2e7d32"
          fontWeight={600}
          maxWidth={isMobile || isTablet ? '40%' : '20%'}
        >
          {code}
        </Text>
        <Box
          width={'100%'}
          maxWidth={isMobile || isTablet ? '50%' : '80%'}
          height={1}
          background={'#2e7d32'}
        />
      </Box>

      {renderCardCycle()}

      <ModalNursery
        isOpen={openModalNursery}
        onClose={handleCloseModalNursery}
        data={dataModalNursery}
      />
    </Box>
  );
};
export default Cycles;
